export const renderInlineParagraph = (doc, title, text, x, y, maxWidth, fontSize) => {
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(fontSize);
    doc.setTextColor(30, 30, 30);
    const prefix = title.trim() + ". ";

    // Get width while the font is set to bold
    const titleWidth = doc.getTextWidth(prefix);
    doc.text(prefix, x, y);

    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(fontSize);
    doc.setTextColor(60, 60, 60);

    const paragraphs = text.split('\n');
    const firstPara = paragraphs[0] || "";
    const words = firstPara.split(/\s+/);
    let currentLine = "";
    let wordIndex = 0;
    const firstLineMax = maxWidth - titleWidth;

    while (wordIndex < words.length) {
        const testLine = currentLine ? currentLine + " " + words[wordIndex] : words[wordIndex];
        if (doc.getTextWidth(testLine) > firstLineMax) {
            break;
        }
        currentLine = testLine;
        wordIndex++;
    }

    doc.text(currentLine, x + titleWidth, y);

    let currentY = y + 10;

    const restOfFirstPara = words.slice(wordIndex).join(" ");
    if (restOfFirstPara) {
        const splitLines = doc.splitTextToSize(restOfFirstPara, maxWidth);
        splitLines.forEach(line => {
            doc.text(line, x, currentY);
            currentY += 10;
        });
    }

    for (let i = 1; i < paragraphs.length; i++) {
        const para = paragraphs[i].trim();
        if (!para) {
            currentY += 4;
            continue;
        }
        const splitLines = doc.splitTextToSize(para, maxWidth);
        splitLines.forEach(line => {
            doc.text(line, x, currentY);
            currentY += 10;
        });
    }

    return currentY;
};
